import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrophy, FiAward, FiStar } = FiIcons;

const Leaderboard = ({ scores }) => {
  const getRankIcon = (index) => {
    switch (index) {
      case 0: return FiTrophy;
      case 1: return FiAward;
      case 2: return FiStar;
      default: return null;
    }
  };

  const getRankColor = (index) => {
    switch (index) {
      case 0: return 'text-yellow-400';
      case 1: return 'text-gray-300';
      case 2: return 'text-orange-400';
      default: return 'text-gray-400';
    }
  };

  if (scores.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
      className="bg-black bg-opacity-60 rounded-lg p-4 max-w-sm mx-auto"
    >
      <h3 className="text-lg font-bold text-orange-400 mb-3 text-center">
        🏆 Top Hunters
      </h3>
      
      <div className="space-y-2">
        {scores.map((entry, index) => (
          <motion.div
            key={`${entry.round}-${entry.score}`}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            className={`flex items-center justify-between p-2 rounded ${
              index === 0 ? 'bg-yellow-900 bg-opacity-30' : 
              index === 1 ? 'bg-gray-800 bg-opacity-30' :
              index === 2 ? 'bg-orange-900 bg-opacity-30' :
              'bg-gray-700 bg-opacity-20'
            }`}
          >
            <div className="flex items-center gap-2">
              {getRankIcon(index) && (
                <SafeIcon 
                  icon={getRankIcon(index)} 
                  className={getRankColor(index)}
                />
              )}
              <span className="text-gray-300 font-medium">
                #{index + 1}
              </span>
            </div>
            
            <div className={`font-bold ${getRankColor(index)}`}>
              {entry.score} pts
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Leaderboard;